import { icons, type LucideProps } from 'lucide-react';
import { HelpCircle } from 'lucide-react';

interface LucideIconProps extends Omit<LucideProps, 'ref'> {
  /** Nom d'icône lucide en kebab-case (ex: 'shopping-cart') ou PascalCase (ex: 'ShoppingCart'). */
  readonly name: string;
}

/**
 * Wrapper pour rendre une icône lucide-react à partir de son nom string.
 * Permet aux modules de déclarer leur icône en string (sérialisable, simple).
 * Fallback sur HelpCircle si le nom est inconnu (log warn une fois).
 */
const warnedNames = new Set<string>();

function toPascalCase(name: string): string {
  return name
    .split(/[-_]/)
    .filter(Boolean)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join('');
}

export function LucideIcon({ name, ...rest }: LucideIconProps): JSX.Element {
  const key = toPascalCase(name) as keyof typeof icons;
  const Component = icons[key];
  if (!Component) {
    if (!warnedNames.has(name)) {
      warnedNames.add(name);
      // eslint-disable-next-line no-console
      console.warn(`[LucideIcon] icône inconnue: "${name}"`);
    }
    return <HelpCircle {...rest} />;
  }
  return <Component {...rest} />;
}
